import { render, staticRenderFns } from "./ConnectDownload.vue?vue&type=template&id=40f6de96"
import script from "./ConnectDownload.vue?vue&type=script&lang=js"
export * from "./ConnectDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports